var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"of-content-1"},[_c('description',{staticClass:"item1",attrs:{"view":_vm.ofContent1.description}}),_vm._v(" "),_c('social-media',{staticClass:"item2",attrs:{"view":_vm.ofContent1.socialMedia}}),_vm._v(" "),_c('tutorial',{staticClass:"item3",attrs:{"view":_vm.ofContent1.tutorial}})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-90a7bade","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/office/js/components/dashboard/onboardingFunnel/content-1/index.vue
// module id = KvRV
// module chunks = 0